<template>
  <div>
    <span class="MOBILE_h12_Regular" :style="{ color }">{{
      $t('buyTickets.saleEnds')
    }}</span
    ><span class="MOBILE_h12_Bold" :style="{ color }"> {{ timerText }}</span>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'BSaleEndTimer',
  props: {
    countdownEnd: {
      type: Date,
      default: null
    },
    color: {
      type: String,
      default() {
        // We need this because the fonts have their own colors specified
        // which override the css color property
        return this.$whitelabel.lightTheme.textPrimary.lighten5;
      }
    }
  },
  data() {
    return {
      endMoment: null,
      intervalId: null,
      timerText: null
    };
  },
  watch: {
    countdownEnd(newValue) {
      this.setTimer(newValue);
    }
  },
  mounted() {
    this.setTimer(this.countdownEnd);
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  methods: {
    setTimer(endTime) {
      clearInterval(this.intervalId);
      if (endTime) {
        this.endMoment = moment(endTime);
        this.startTimer();
      } else {
        this.endMoment = null;
      }
    },
    startTimer() {
      this.timerTick();
      this.intervalId = setInterval(this.timerTick, 1000);
    },
    timerTick() {
      const durationLeft = moment.duration(this.endMoment.diff(moment()));
      this.timerText = this.formatDuration(durationLeft);
      if (durationLeft.asMilliseconds() <= 0) {
        clearInterval(this.intervalId);
        this.$emit('timer-end');
      }
    },
    formatDuration(duration) {
      const hourDuration = moment
        .utc(duration.asMilliseconds())
        .format('H[H] m[M] s[S]');
      // Convert months, years to days
      const days = Math.floor(duration.asDays());
      // Don't show days if there is less than 1 day left
      if (days > 0) {
        return `${days}D ${hourDuration}`;
      }
      return hourDuration;
    }
  }
};
</script>
